import React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"
import PropTypes from "prop-types"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-neutral-10 text-neutral-1",
        secondary: "border-transparent bg-secondary-6 text-secondary-2",
        success: "border-transparent bg-label-green-1 text-label-green-2",
        warning: "border-transparent bg-label-orange-1 text-label-orange-2", 
        error: "border-transparent bg-label-red-1 text-label-red-2",
        info: "border-transparent bg-label-blue-1 text-label-blue-2",
        outline: "text-neutral-10 border-neutral-5",
        // Loan status specific variants
        "under-review": "border-transparent bg-label-orange-1 text-label-orange-2",
        submitted: "border-transparent bg-label-green-1 text-label-green-2",
        funded: "border-transparent bg-label-green-2 text-neutral-1",
        draft: "border-transparent bg-label-gray-1 text-label-gray-2",
        withdrawn: "border-transparent bg-label-red-1 text-label-red-2",
        rejected: "border-transparent bg-label-red-2 text-neutral-1",
        // Bank account labels
        "manually-added": "border-transparent bg-label-pink-1 text-label-pink-2",
        "plaid-verified": "border-transparent bg-label-purple-1 text-label-purple-2",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

Badge.propTypes = {
  variant: PropTypes.oneOf([
    "default",
    "secondary",
    "success",
    "warning",
    "error",
    "info",
    "outline",
    "under-review",
    "submitted",
    "funded",
    "draft",
    "withdrawn",
    "rejected",
    "manually-added",
    "plaid-verified",
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
};


export { Badge, badgeVariants }
